export enum BazaNcIntegrationSubscribeMessages {
    ComingSoonMovedToOpen = 'ComingSoonMovedToOpen',
}
